import { baseApi } from "./baseApi";

const API_PERFORMANCE_LOG_BASE_URL = "/api-performance-logs";

export const apiPerformanceLogApi = baseApi.injectEndpoints({
  tagTypes: ["ApiPerformanceLog"],
  endpoints: (build) => ({
    getApiPerformanceLogs: build.query({
      query: (params) => ({
        url: `${API_PERFORMANCE_LOG_BASE_URL}`,
        params,
      }),
      providesTags: ["ApiPerformanceLog"],
    }),
    getApiPerformanceSpikes: build.query({
      query: (params) => ({
        url: `${API_PERFORMANCE_LOG_BASE_URL}/analytics/spikes`,
        params,
      }),
      providesTags: ["ApiPerformanceLog"],
    }),
    getApiPerformanceFrequency: build.query({
      query: (params) => ({
        url: `${API_PERFORMANCE_LOG_BASE_URL}/analytics/frequency`,
        params,
      }),
      providesTags: ["ApiPerformanceLog"],
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetApiPerformanceLogsQuery,
  useGetApiPerformanceSpikesQuery,
  useGetApiPerformanceFrequencyQuery,
} = apiPerformanceLogApi;
